jQuery(function($) {
    // Function to handle hover and activate the blur overlay
    function activateBlurOnHover(hoverClass) {
        $(hoverClass).on('mouseenter', function() {
            $('.site-overlay-blur').addClass('active');
        });

        $(hoverClass).on('mouseleave', function() {
            $('.site-overlay-blur').removeClass('active');
        });
    }

    activateBlurOnHover('.has-mega');
});